import { AssetEvolution } from './components/AssetEvolution';
import { AverageTicket } from './components/AverageTicket';

export const financialAnalysisTypes = {
  assetEvolution: AssetEvolution,
  averageTicket: AverageTicket,
};

export type FinancialAnalysisType = keyof typeof financialAnalysisTypes;

export const financialAnalysisTypeList = Object.keys(
  financialAnalysisTypes
) as FinancialAnalysisType[];

export const defaultFinancialAnalysisType = financialAnalysisTypeList[0];

export const financialAnalysisTypesLabels: Record<FinancialAnalysisType, string> = {
  averageTicket: 'Ticket Médio - Captação',
  assetEvolution: 'Evolução Patrimonial',
};

export const chartNameMap = new Map([['ticketAverageValue', 'Ticket médio - captação líquida']]);
